@if (publicAccessLevel() !== 'no_access' && !(gallery.tenant || state.activeTenant)['block_public_link_access']) {
  <app-editable-gallery-url-field
    [gallery]="gallery"
    [asset]="asset"
    [accessLevel]="'view_only'"
    (onEditingPathChange)="isEditingPath.set($event)"
  ></app-editable-gallery-url-field>
  @if (!loading()) {
    <div class="main-container" [class.disabled]="isEditingPath()">
      @if (gallery.password_enabled) {
        <div class="access-list-container">
          <div class="access-list">
            <div class="access-list-item">
              <div class="access-list-icon orange">
                <app-svg src="/assets/icons/lock.svg"></app-svg>
              </div>
              <div class="access-list-info no-overflow-protect">
                <div class="info-main">Password is set</div>
              </div>
              <div class="access-list-action">
                <button
                  appButton
                  name="copy-password"
                  location="share-sub-gallery-link"
                  [copy-clipboard]="gallery['password']"
                  color="gray-bordered"
                  weight="bold"
                  size="1"
                  height="1"
                  (click)="onPasswordCopied()"
                >
                  <span>• • • • • Copy</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      }
      <app-share-gallery-social-links
        [gallery]="gallery"
        [asset]="asset"
        [disabled]="isEditingPath()"
      ></app-share-gallery-social-links>
    </div>
  }
} @else {
  <div class="rounded-banner warn">
    <app-svg src="/assets/icons/globe-disabled.svg"></app-svg>
    <span>Link access is disabled.</span>
    <button
      appButton
      name="enable-access"
      location="share-sub-gallery-link"
      color="warn"
      shape="round"
      height="1"
      (click)="openGallerySharing()"
    >
      Manage
    </button>
  </div>
}
